module.exports = __webpack_public_path__ + "static/media/rooftop_siamese.c245c097.png";